import type { AddNoteRequest } from '@contracts/note/AddNoteRequest';
import { OrdersClient } from '@src/orders/services/OrdersClient';
import { useMutation } from '@tanstack/react-query';

type Props = {
  onSuccess: () => void;
  onError: () => void;
};

export const usePutOnHoldOrder = ({ onSuccess, onError }: Props) => {
  const { mutate } = useMutation({
    mutationFn: (data: { orderId: string; note: AddNoteRequest }) =>
      OrdersClient.putOnHold({ orderId: data.orderId, note: data.note }),
    onSuccess,
    onError,
  });

  return {
    putOnHold: mutate,
  };
};
